// GT06 parameter requests wait up to 15 seconds on the server. Leave room for
// transport and persistence; a client timeout never triggers a repeated command.
export function requestTimeoutMs(path,method,ordinaryMs){
 if(method==='POST'&&/^\/api\/devices\/[A-Za-z0-9_-]{4,32}\/gps-(interval|sleep|acc)$/.test(path))return Math.max(ordinaryMs,30000);
 return method==='POST'&&/^\/api\/devices\/[A-Za-z0-9_-]{4,32}\/gps-parameters$/.test(path)?Math.max(ordinaryMs,20000):ordinaryMs;
}
